import { render } from "./StockNotification.vue?vue&type=template&id=323aaf6a&scoped=true"
import script from "./StockNotification.vue?vue&type=script&lang=js"
export * from "./StockNotification.vue?vue&type=script&lang=js"

import "./StockNotification.vue?vue&type=style&index=0&id=323aaf6a&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323aaf6a"]])

export default __exports__